import { useEffect, useState } from "react";
import { collection, onSnapshot, orderBy, query } from "firebase/firestore";
import { db } from "../../../firebase";
import { PARTNER_CONTRACT_DOCUMENT_ID } from "../../../services/partnerContractLink";

const fallbackLinks = [
  {
    id: "catalog-default",
    title: "Каталог",
    url: "https://drive.google.com/drive/folders/1FVFYuIufuMmrvwhmviehPI7S80dIrhZ3",
    isActive: true,
  },
  {
    id: "price-default",
    title: "Завантажити прайс",
    url: "https://docs.google.com/spreadsheets/d/1K4ZJJXsdFtRWL5a14AtTMyWe-YMpnsxTXOJjLO8YHIw/edit#gid=1616448480",
    isActive: true,
  },
];

export default function FooterDynamicLinks() {
  const [links, setLinks] = useState(fallbackLinks);

  useEffect(() => {
    const q = query(collection(db, "footerLinks"), orderBy("order", "asc"));

    const unsubscribe = onSnapshot(
      q,
      (snapshot) => {
        const list = snapshot.docs
          .map((doc) => ({
            id: doc.id,
            ...doc.data(),
          }))
          .filter((item) => item.id !== PARTNER_CONTRACT_DOCUMENT_ID)
          .filter((item) => item.isActive !== false)
          .filter((item) => item.title && item.url);

        setLinks(list.length > 0 ? list : fallbackLinks);
      },
      (error) => {
        console.error("Footer links load error:", error);
        setLinks(fallbackLinks);
      },
    );

    return () => unsubscribe();
  }, []);

  return (
    <>
      {links.map((item) => (
        <li className="centerSecondLi" key={item.id}>
          <a
            className="centerSecondLi"
            href={item.url}
            target="_blank"
            rel="noopener noreferrer"
          >
            {item.title}
          </a>
        </li>
      ))}
    </>
  );
}
